<template>
  <div class="live-container" :style="containerStyle" @touchstart="handleTouchStart" @touchmove.prevent="handleTouchMove" @touchend="handleTouchEnd">
    <!-- 顶部公告 -->
    <van-notice-bar
      left-icon="volume-o"
      :text="baseData.tip_content || '通知公告：直播开始时间为晚上 10 点至凌晨 4 点，精彩不容错过！'"
      color="#ffffff"
      background="#f57162"
      class="custom-notice"
    />

    <!-- 视频播放层：点播视频（独立控制） -->
    <div class="video-layer" v-show="showPlayer && playType === 'video'" :style="{ backgroundColor: isVideoReady ? '#000' : 'transparent' }">
      <div
        id="vod-player"
        class="native-video"
        :style="{ backgroundColor: isVideoReady ? '#000' : 'transparent' }"
      ></div>
    </div>

    <!-- 视频播放层：直播流（独立控制） -->
    <div class="video-layer" v-show="showPlayer && playType === 'live'" style="background-color: #000; pointer-events: none;">
      <div
        id="live-player"
        class="native-video no-controls"
        style="background-color: #000; pointer-events: none;"
      ></div>
    </div>

    <!-- 底部操作栏 (精选、精品、视频、直播 + 原本的播放控制按钮) -->
    <div class="bottom-controls">
      <!-- 原先的右侧分类按钮，现在移到了底部上方 -->
      <div class="category-row">
        <div class="category-btn-item" @click="goHome">
          <div class="category-icon-wrap btn-yellow">
            <van-icon name="star" />
          </div>
          <span>精选</span>
        </div>

        <div class="category-btn-item" @click="goHome">
          <div class="category-icon-wrap btn-orange">
            <van-icon name="gem" />
          </div>
          <span>精品</span>
        </div>

        <div class="category-btn-item" @click="playVodStream">
          <div class="category-icon-wrap btn-pink">
            <van-icon name="play-circle-o" />
          </div>
          <span>视频</span>
        </div>

        <div class="category-btn-item" @click="playLiveStream">
          <div class="category-icon-wrap btn-red">
            <van-icon name="video-o" />
          </div>
          <span>直播</span>
        </div>
      </div>

      <!-- 原本的播放控制栏（仅在视频模式显示） -->
      <div class="control-row" v-if="playType === 'video'">
        <div class="btn-item btn-large btn-gradient" @click="handlePlay">
          <div class="icon-wrap play-icon">
            <van-icon :name="isPlaying ? 'pause' : 'play'" />
          </div>
          <span class="btn-text-large">{{ isPlaying ? '暂停播放' : '开始播放' }}</span>
        </div>

        <div class="btn-item btn-small btn-dark-trans" @click="toggleContinuous">
          <van-icon name="replay" :class="isContinuous ? 'icon-yellow' : 'icon-white'" />
          <div class="btn-text-stack">
            <span :style="{ color: isContinuous ? '#f1c40f' : '#fff' }">连续</span>
            <span :style="{ color: isContinuous ? '#f1c40f' : '#fff' }">播放</span>
          </div>
        </div>

        <div class="btn-item btn-small btn-dark-trans" @click="playNextVideo">
          <van-icon name="play-circle" class="icon-white" />
          <div class="btn-text-stack">
            <span :style="{ color: isContinuous ? '#f1c40f' : '#fff' }">下个</span>
            <span :style="{ color: isContinuous ? '#f1c40f' : '#fff' }">视频</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 详情弹窗 -->
    <van-dialog
      class="demo-dialog van-dialog detail-box"
      v-model="payBoxModal"
      :before-close="closeDig"
      :showConfirmButton="false"
      :showCancelButton="false"
      :closeOnClickOverlay="true"
    >
      <div class="pay-title" style="color:#fff;text-align: center;font-size: 16px;padding: 15px 0;">
        付费即可观看完整视频
      </div>

      <div class="pay-btn-box">
        <van-button
          round
          v-for="(item, index) in payBtnList"
          :key="index"
          class="index-pay-item"
          :color="item.color || '#4caf50'"
          :style="{
            background: (item.color || '#4caf50') + ' !important',
            color: '#fff !important',
            border: 'none',
            margin: '5px auto',
            width: '80%',
            display: 'block'
          }"
          @click="linkTo(item)"
        >
          <div style="display: flex;flex-direction: column;align-items: center;">
            <span style="color:#fff;">{{ item.name }}</span>
          </div>
        </van-button>
      </div>

      <div class="pay-code-section">
        <div class="pay-code-tip">请及时保存口令，方便找回已购</div>
        <div class="pay-code-box">
          <div class="pay-code-text">{{ shareDataInfo.shareAgentCode }}</div>
          <div class="pay-code-copy" @click="handelClickCopy(shareDataInfo.shareAgentCode)">复制</div>
        </div>
      </div>

      <div class="pay-action-btns">
        <div class="pay-action-btn close-btn" @click="closeDigNew">关闭</div>
      </div>
    </van-dialog>

    <!-- 支付弹窗 -->
    <van-action-sheet v-model="payModal" title="支付通道">
      <div class="pay-card">
        <div
          class="pay-list"
          style="display:flex;align-items: center;flex-direction:row;justify-content: space-around;"
        >
          <div
            class="pay-item"
            v-for="(item, index) in payList"
            :key="index"
            @click="goPayOrder(item.id)"
            style="display: flex;flex-direction: column;align-items: center;"
          >
            <img
              class="picon"
              style="width: 150px;height: 56px;"
              src="../assets/alipay.png"
              v-if="item.pay_channel == 'alipay'"
            />

            <img
              class="picon"
              style="width: 150px;height: 56px;"
              src="../assets/wechat.png"
              v-if="item.pay_channel == 'wxpay'"
            />

            <div class="pay-name" style="display: flex;flex-direction: column;align-items: center;width: 100%;">
              <span v-if="item.pay_channel == 'alipay'" class="txt">推荐使用</span>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>

    <!-- 分享提示弹窗 -->
    <van-dialog
      v-model="showShareModal"
      class="cyber-share-dialog"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="cyber-share-container">
        <div class="cyber-share-header">
          <van-icon name="share-o" class="header-icon" />
          <span class="header-title">解锁更多观看次数</span>
        </div>
        
        <div class="cyber-share-body">
          <div class="tips-card">
            免费观看次数已用完，<span class="highlight">分享至三个人或者群聊可增加3次或者10次免费观看次数</span>
          </div>

          <div class="link-card">
            <div class="link-title">
              <van-icon name="link-o" /> 高清视频请复制到浏览器永久打开:
            </div>
            <div class="link-content">
              
              <div class="link-url">{{ shareUrl }}</div>
            </div>
          </div>
        </div>

        <div class="cyber-share-footer">
          <div class="cyber-btn cyber-btn-cancel" @click="handleShareDone">我已分享</div>
          <div class="cyber-btn cyber-btn-confirm" @click="handleGoShare">复制链接</div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { initData, getVideo, pvv6Api, pav7Api, liveShareLogApi, getLiveVideo } from "@/api/api";
import bplayer from '@/utils/bplayer';

export default {
  name: "LiveIndex",

  data() {
    return {
      baseData: {},
      
      vodPlayerInstance: null,
      livePlayerInstance: null,

      isPlaying: false,
      showPlayer: false,
      isContinuous: false,

      currentVideoUrl: "",
      playType: "video",
      currentVideoId: null,

      /**
       * 修复 AbortError 的关键状态
       * isChangingVideo：正在切换视频，避免 timeupdate/click 重复触发 pause/play
       * isAutoPlaying：正在执行 play()，避免 play() 未完成又被 pause()
       * lastPlayUrl：记录上一次播放地址，避免重复 load()
       */
      isChangingVideo: false,
      isAutoPlaying: false,
      lastPlayUrl: "",
      isVideoReady: false,

      /**
       * 保留字段，避免你其他地方如果有引用不会报错。
       * 现在不再使用 xgplayer。
       */
      try_pay_player: null,

      payBoxModal: false,
      payModal: false,
      payBtnList: [],
      payList: [],
      goodsInfo: null,

      shareDataInfo: {
        shareAgentCode: ""
      },

      params: {
        ldk: "",
        uid: ""
      },

      showShareModal: false,
      is_jump: 0,

      // 滑动参数
      startY: 0,
      endY: 0
    };
  },

  computed: {
    containerStyle() {
      // 直播板块不显示背景图，保持纯黑背景
      if (this.playType === 'live') {
        return {
          backgroundColor: '#000'
        };
      }

      let bgImg = "";
      
      // 如果当前是视频，优先用视频的封面
      if (this.playType === 'video' && this.baseData.video && this.baseData.video.thumb_image) {
        bgImg = this.baseData.video.thumb_image;
      }

      if (!bgImg && this.baseData.live_thumb_image) {
        bgImg = this.baseData.live_thumb_image;
      }

      if (!bgImg) {
        bgImg = "https://img1.baidu.com/it/u=3007963384,1832049015&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=889";
      }

      return {
        backgroundImage: `url(${bgImg})`,
        backgroundColor: '#000'
      };
    },

    shareUrl() {
      return this.baseData.shareUrl || "";
    }
  },

  created() {
    this.params.ldk = this.$route.query.ldk || window.localStorage.getItem("ldk") || "";
    this.params.uid = this.$route.query.uid || window.localStorage.getItem("visitorId") || "";
    this.shareDataInfo.shareAgentCode = window.localStorage.getItem("shareAgentCode") || "";

    const payListStr = window.localStorage.getItem("payList");

    if (payListStr) {
      try {
        this.payList = JSON.parse(payListStr);
      } catch (e) {}
    }

    this.fetchBaseData();
  },

  beforeDestroy() {
    this.destroyPlayer(true);
  },

  methods: {
    handleTouchStart(e) {
      if (this.playType === 'video') return; // 视频板块禁用滑动
      this.startY = e.touches[0].clientY;
      this.endY = this.startY;
    },
    handleTouchMove(e) {
      if (this.playType === 'video') return; // 视频板块禁用滑动
      this.endY = e.touches[0].clientY;
    },
    handleTouchEnd() {
      if (this.playType === 'video') return; // 视频板块禁用滑动
      if (this.startY === 0 || this.endY === 0) return;
      
      const diffY = this.startY - this.endY;
      // 设置滑动阈值，例如 50px
      if (diffY > 50) {
        // 上滑，切换下一个直播
        if (this.playType === 'live') {
          this.playNextLive();
        }
      } else if (diffY < -50) {
        // 下滑
        this.$toast('已经是当前最新视频了');
      }
      
      // 重置
      this.startY = 0;
      this.endY = 0;
    },

    fetchBaseData() {
      const query = this.$route.query;

      initData(query)
        .then(res => {
          if (res) {
            const temp = JSON.parse(this.$decryptData(res));
            this.baseData = temp;
              this.currentVideoUrl = temp.video.url;
              this.playType = "video";
          }
        })
        .catch(err => {
          // 忽略异常
        });
    },

    getCurrentPlayer() {
      return this.playType === 'video' ? this.vodPlayerInstance : this.livePlayerInstance;
    },

    stopAllPlayers() {
      if (this.vodPlayerInstance) {
        try {
          this.vodPlayerInstance.pause();
        } catch (e) {}
      }
      if (this.livePlayerInstance) {
        try {
          this.livePlayerInstance.pause();
        } catch (e) {}
      }
    },

    /**
     * 初始化/切换 点播视频
     */
    createDetailPlayer(videoInfo) {
      if (!videoInfo || !videoInfo.link) {
        this.$toast("视频地址为空");
        return;
      }

      let newUrl = videoInfo.link;
      //newUrl='https://jsts260724.ss082213-us.bajie999.cn/20260209/Hg009Ir9/index.m3u8';
      this.isChangingVideo = true;
      this.isAutoPlaying = false;
      this.showPlayer = true;
      this.isPlaying = false;
      this.isVideoReady = false;

      this.$nextTick(() => {
        if (this.vodPlayerInstance) {
          this.vodPlayerInstance.pause();
          this.vodPlayerInstance.destroy();
          this.vodPlayerInstance = null;
        }
        console.log('newUrl', newUrl);
        
        this.vodPlayerInstance = new Player({
          id: 'vod-player',
          url: newUrl,
          playsinline: true,
          height: '220px',
          "x5-video-player-fullscreen": "false",
          "x5-video-orientation": "portraint",
          "x5-video-player-type": "h5",
          fluid: true,
          closeVideoClick: true,
          closeVideoDblclick: true,
          closeVideoTouch: true,
          closePlayerBlur: true,
          closeControlsBlur: true,
          closeFocusVideoFocus: true,
          closePlayVideoFocus: true,
          enableContextmenu: true
        });

        // 禁止点击事件触发播放/暂停
        const playerElement = document.getElementById('vod-player');
        if (playerElement) {
          playerElement.addEventListener('click', (e) => {
            e.stopPropagation();
          });
          playerElement.addEventListener('touchend', (e) => {
            e.stopPropagation();
          });
        }

        this.vodPlayerInstance.start();

        this.vodPlayerInstance.on('ended', this.handleVideoEnded);
        this.vodPlayerInstance.on('timeupdate', this.handleNativeTimeUpdate);
        this.vodPlayerInstance.on('play', this.handleNativePlay);
        this.vodPlayerInstance.on('pause', this.handleNativePause);
        this.vodPlayerInstance.on('error', this.handleNativeError);

        this.currentVideoUrl = newUrl;
        this.lastPlayUrl = newUrl;

        setTimeout(() => {
          this.isChangingVideo = false;
          this.safePlayVideo();
        }, 120);
      });
    },

    /**
     * 原生video初始化（xgplayer不需要此方法，但为了防止报错暂时保留为空）
     */
    initNativeVideo() {
      // 废弃，改用 xgplayer
    },

    /**
     * 安全播放方法：
     */
    safePlayVideo() {
      const player = this.getCurrentPlayer();

      if (!player) return;

      if (this.isAutoPlaying) {
        return;
      }

      this.showPlayer = true;
      this.isAutoPlaying = true;

      let playPromise = null;

      try {
        playPromise = player.play();
      } catch (err) {
        this.isPlaying = false;
        this.isAutoPlaying = false;
        this.$toast("请点击开始播放");
        return;
      }

      if (playPromise && typeof playPromise.then === "function") {
        playPromise
          .then(() => {
            this.isPlaying = true;
            this.isAutoPlaying = false;
          })
          .catch(err => {
            this.isPlaying = false;
            this.isAutoPlaying = false;

            if (err && err.name === "AbortError") {
              return;
            }

            this.showPlayer = true;
            this.$toast("请点击开始播放");
          });
      } else {
        this.isPlaying = true;
        this.isAutoPlaying = false;
      }
    },

    /**
     * 点击视频画面切换播放/暂停状态 (废弃)
     */
    toggleNativeVideo() {
      return false;
    },

    handleNativePlay() {
      this.isVideoReady = true;
      this.isPlaying = true;
      this.showPlayer = true;
    },

    handleNativePause() {
      /**
       * 切换视频过程中触发 pause 是正常现象，不要影响状态。
       */
      if (this.isChangingVideo) {
        return;
      }

      this.isPlaying = false;
    },

    handleNativeError(e) {
      this.isPlaying = false;
      this.isAutoPlaying = false;
      this.isChangingVideo = false;
      this.showPlayer = true;
      this.$toast("视频加载失败");
    },

    handleNativeTimeUpdate() {
      const video = this.getCurrentPlayer();
      if (video && video.currentTime > 0) {
        this.isVideoReady = true;
      }
      this.handlePlayerTimeUpdate();
    },

    playBplayer() {
      this.safePlayVideo();
    },

    /**
     * 销毁播放器
     * clearSrc=true：离开页面、返回首页时清空 src
     * clearSrc=false：普通暂停，不清空 src，避免打断播放
     */
    destroyPlayer(clearSrc = true) {
      if (clearSrc) {
        this.stopAllPlayers();
        if (this.vodPlayerInstance) {
          this.vodPlayerInstance.destroy();
          this.vodPlayerInstance = null;
        }
        if (this.livePlayerInstance) {
          this.livePlayerInstance.destroy();
          this.livePlayerInstance = null;
        }
        this.lastPlayUrl = "";
      }

      this.try_pay_player = null;
      this.isPlaying = false;
      this.isAutoPlaying = false;
      this.isChangingVideo = false;
      this.isVideoReady = false;
    },

    handlePlay() {
      if (!this.currentVideoUrl) {
        return this.$toast("暂无视频资源可播放");
      }

      const video = this.getCurrentPlayer();

      /**
       * 正在切换或自动播放时，防止重复点击造成 AbortError。
       */
      if (this.isChangingVideo || this.isAutoPlaying) {
        return;
      }

      /**
       * 已经显示播放器，直接控制原生 video 播放/暂停。
       */
      if (this.showPlayer && video && video.src) {
        this.initNativeVideo(video);

        if (this.isPlaying) {
          video.pause();
          this.isPlaying = false;
          return;
        }

        if (this.playType === "video" && video.currentTime >= 300) {
          if (this.isContinuous) {
            this.playNextVideo();
          } else {
            this.$toast("该视频已看完，请播放下个视频");
          }

          return;
        }

        this.playBplayer();
        return;
      }

      /**
       * 没有显示播放器或没加载src，此时点击“开始播放”才去加载真实的视频地址并播放。
       */
      this.startPlayForce();
    },

    startPlayForce() {
      if (this.playType === "video") {
        if (this.currentVideoId !== (this.baseData.video ? this.baseData.video.id : null)) {
          if (!this.checkPlayLimit(true)) return;
          this.currentVideoId = this.baseData.video ? this.baseData.video.id : null;
        }
      }

      this.showPlayer = true;
      this.isPlaying = false;

      this.stopAllPlayers();

      this.$nextTick(() => {
        if (this.playType === "video") {
          this.createDetailPlayer({
            link: this.currentVideoUrl,
            thumb_image: this.baseData.video ? this.baseData.video.thumb_image : ""
          });
        } else {
          this.createLivePlayer({
            link: this.currentVideoUrl
          });
        }
      });
    },

    /**
     * 初始化 直播视频
     */
    createLivePlayer1111(videoInfo) {
      if (!videoInfo || !videoInfo.link) {
        this.$toast("直播地址为空");
        return;
      }

      const newUrl = videoInfo.link;

      this.isChangingVideo = true;
      this.isAutoPlaying = false;
      this.showPlayer = true;
      this.isPlaying = false;
      this.isVideoReady = false;

      this.$nextTick(() => {
        if (this.livePlayerInstance) {
          this.livePlayerInstance.pause();
          this.livePlayerInstance.destroy();
          this.livePlayerInstance = null;
        }

        // this.livePlayerInstance = new Player({
        //   id: 'live-player',
        //   url: newUrl,
        //   playsinline: true,
        //   height: '220px',
        //   "x5-video-player-fullscreen": "false",
        //   "x5-video-orientation": "portraint",
        //   "x5-video-player-type": "h5",
        //   fluid: true,
        //   controls: false, // 直播模式不显示控件
        //   closeVideoClick: true,
        //   closeVideoDblclick: true,
        //   closeVideoTouch: true,
        //   closePlayerBlur: true,
        //   closeControlsBlur: true,
        //   closeFocusVideoFocus: true,
        //   closePlayVideoFocus: true,
        //   enableContextmenu: true
        // });

        // 直播模式也阻止事件冒泡
       this.livePlayerInstance = new Player({
          id: 'live-player',
          url: newUrl,

          playsinline: true,

          width: '100%',
          height: '220px',

          // X5
          "x5-video-player-fullscreen": "false",
          "x5-video-orientation": "portrait",
          "x5-video-player-type": "h5",

          fluid: false,

          // 隐藏所有控制
          controls: false,

          // 禁止视频点击暂停
          closeVideoClick: true,

          // 禁止双击
          closeVideoDblclick: true,

          // 禁止触摸控制
          closeVideoTouch: true,

          // 禁止失焦暂停
          closePlayerBlur: true,
          closeControlsBlur: true,

          // 禁止聚焦播放
          closeFocusVideoFocus: true,
          closePlayVideoFocus: true,

          // 禁止右键菜单
          enableContextmenu: false,

          // 禁止拖动进度
          ignores: [
              'time',
              'progress',
              'play',
              'volume',
              'fullscreen'
          ]
      });
        const playerElement = document.getElementById('live-player');
        if (playerElement) {
          playerElement.addEventListener('click', (e) => {
            e.stopPropagation();
          });
          playerElement.addEventListener('touchend', (e) => {
            e.stopPropagation();
          });
        }

        this.livePlayerInstance.start();

        this.livePlayerInstance.on('ended', this.handleVideoEnded);
        this.livePlayerInstance.on('timeupdate', this.handleNativeTimeUpdate);
        this.livePlayerInstance.on('play', this.handleNativePlay);
        this.livePlayerInstance.on('pause', this.handleNativePause);
        this.livePlayerInstance.on('error', this.handleNativeError);

        this.currentVideoUrl = newUrl;
        this.lastPlayUrl = newUrl;

        setTimeout(() => {
          this.isChangingVideo = false;
          this.safePlayVideo();
        }, 120);
      });
    },
    createLivePlayer2222(videoInfo) {
      if (!videoInfo || !videoInfo.link) {
        this.$toast("直播地址为空");
        return;
      }

      let newUrl = videoInfo.link;

      this.isChangingVideo = true;
      this.isAutoPlaying = false;
      this.showPlayer = true;
      this.isPlaying = false;
      this.isVideoReady = false;

      this.$nextTick(() => {

        if (this.livePlayerInstance) {
          this.livePlayerInstance.pause();
          this.livePlayerInstance.destroy();
          this.livePlayerInstance = null;
        }

        this.livePlayerInstance = new Player({

          id: 'live-player',

          url: newUrl,

          // 内联播放
          playsinline: true,

          width: '100%',
          height: '220px',

          // QQ浏览器X5
          "x5-video-player-fullscreen": "false",
          "x5-video-orientation": "portrait",
          "x5-video-player-type": "h5",

          // 不使用自适应高度
          fluid: false,


          // 隐藏播放器控制栏
          controls: false,


          // 禁止所有交互
          closeVideoClick: true,
          closeVideoDblclick: true,
          closeVideoTouch: true,


          // 禁止失焦暂停
          closePlayerBlur: true,
          closeControlsBlur: true,


          // 禁止焦点操作
          closeFocusVideoFocus: true,
          closePlayVideoFocus: true,


          // 禁止右键菜单
          enableContextmenu: false

        });


      const playerElement = document.getElementById('live-player');


      if (playerElement) {

        // 阻止播放器点击事件
        playerElement.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
        }, true);


        // 阻止触摸事件
        playerElement.addEventListener('touchstart', (e) => {
          e.preventDefault();
          e.stopPropagation();
        }, {
          passive: false,
          capture: true
        });


        playerElement.addEventListener('touchend', (e) => {
          e.preventDefault();
          e.stopPropagation();
        }, {
          passive: false,
          capture: true
        });

      }



      this.livePlayerInstance.start();



      // 强制处理原生video
      setTimeout(() => {

        const video = document.querySelector('#live-player video');


        if (video) {

          // 去掉原生控件
          video.controls = false;
          video.removeAttribute('controls');


          // X5内联播放
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          video.setAttribute('x5-playsinline', '');

          video.setAttribute(
            'x5-video-player-type',
            'h5'
          );

          video.setAttribute(
            'x5-video-player-fullscreen',
            'false'
          );


          // 禁止video交互
          video.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
          }, true);


          video.addEventListener('touchstart', (e) => {
            e.preventDefault();
            e.stopPropagation();
          }, {
            passive:false,
            capture:true
          });

        }


      },300);



      this.livePlayerInstance.on(
        'ended',
        this.handleVideoEnded
      );


      this.livePlayerInstance.on(
        'timeupdate',
        this.handleNativeTimeUpdate
      );


      this.livePlayerInstance.on(
        'play',
        this.handleNativePlay
      );


      this.livePlayerInstance.on(
        'pause',
        this.handleNativePause
      );


      this.livePlayerInstance.on(
        'error',
        this.handleNativeError
      );


      this.currentVideoUrl = newUrl;
      this.lastPlayUrl = newUrl;



      setTimeout(() => {

        this.isChangingVideo = false;

        this.safePlayVideo();

      },120);


    });
    },
    createLivePlayer(videoInfo) {

      if (!videoInfo || !videoInfo.link) {
        this.$toast("直播地址为空");
        return;
      }


      const newUrl = videoInfo.link;


      this.isChangingVideo = true;
      this.isAutoPlaying = false;
      this.showPlayer = true;
      this.isPlaying = false;
      this.isVideoReady = false;



      this.$nextTick(() => {


        // 销毁旧播放器
        if (this.livePlayerInstance) {

          try {

            this.livePlayerInstance.pause();

            this.livePlayerInstance.destroy();

          } catch (e) {}

          this.livePlayerInstance = null;

        }



        this.livePlayerInstance = new Player({

          id: 'live-player',

          url: newUrl,


          // 内联播放
          playsinline:true,


          width:'100%',

          height:'220px',



          // QQ浏览器X5配置
          "x5-video-player-type":"h5",

          "x5-video-player-fullscreen":"false",

          "x5-video-orientation":"portrait",



          // 固定尺寸，不使用fluid
          fluid:false,



          // 关闭控制栏
          controls:false,


          // 不初始化控制组件
          ignores:[

            'play',

            'time',

            'progress',

            'volume',

            'fullscreen',

            'replay',

            'loading',

            'poster'

          ],



          // 禁止交互

          closeVideoClick:true,

          closeVideoDblclick:true,

          closeVideoTouch:true,


          closePlayerBlur:true,

          closeControlsBlur:true,


          closeFocusVideoFocus:true,

          closePlayVideoFocus:true,


          enableContextmenu:false


        });




        const playerElement =
          document.getElementById('live-player');



        if(playerElement){


          // 阻止播放器点击

          playerElement.addEventListener(
            'click',
            (e)=>{

              e.preventDefault();

              e.stopPropagation();

            },
            true
          );



          // 阻止触摸

          playerElement.addEventListener(
            'touchstart',
            (e)=>{

              e.preventDefault();

              e.stopPropagation();

            },
            {
              passive:false,
              capture:true
            }
          );



          playerElement.addEventListener(
            'touchend',
            (e)=>{

              e.preventDefault();

              e.stopPropagation();

            },
            {
              passive:false,
              capture:true
            }
          );


        }





        // 开始播放

        this.livePlayerInstance.start();





        /**
         * 清理所有播放器UI
         */
        setTimeout(()=>{


          const player =
            document.getElementById('live-player');



          if(player){


            const removeControls=[


              // 控制条

              '.xgplayer-controls',

              '.xgplayer-bottom-bar',


              // 播放按钮

              '.xgplayer-play',


              // 进度条

              '.xgplayer-progress',


              // 全屏

              '.xgplayer-fullscreen',


              // 时间

              '.xgplayer-time',


              // 音量

              '.xgplayer-volume',


              // 移动端控制

              '.xgplayer-mobile-controls',


              // loading

              '.xgplayer-loading'


            ];



            removeControls.forEach(selector=>{


              const el =
                player.querySelector(selector);


              if(el){

                el.style.display='none';

              }


            });


          }





          // 原生video处理

          const video =
            document.querySelector('#live-player video');



          if(video){



            video.controls=false;

            video.removeAttribute('controls');



            // X5内联

            video.setAttribute(
              'playsinline',
              ''
            );


            video.setAttribute(
              'webkit-playsinline',
              ''
            );


            video.setAttribute(
              'x5-playsinline',
              ''
            );



            video.setAttribute(
              'x5-video-player-type',
              'h5'
            );



            video.setAttribute(
              'x5-video-player-fullscreen',
              'false'
            );




            // 禁止点击暂停

            video.addEventListener(
              'click',
              (e)=>{

                e.preventDefault();

                e.stopPropagation();

              },
              true
            );




            // 禁止手势

            video.addEventListener(
              'touchstart',
              (e)=>{

                e.preventDefault();

                e.stopPropagation();

              },
              {
                passive:false,
                capture:true
              }
            );


          }



        },500);






        // 播放事件

        this.livePlayerInstance.on(
          'ended',
          this.handleVideoEnded
        );



        this.livePlayerInstance.on(
          'timeupdate',
          this.handleNativeTimeUpdate
        );



        this.livePlayerInstance.on(
          'play',
          this.handleNativePlay
        );



        this.livePlayerInstance.on(
          'pause',
          this.handleNativePause
        );



        this.livePlayerInstance.on(
          'error',
          this.handleNativeError
        );





        this.currentVideoUrl = newUrl;

        this.lastPlayUrl = newUrl;





        setTimeout(()=>{


          this.isChangingVideo=false;


          this.safePlayVideo();



        },120);



      });

    },

    /**
     * 试看 30 秒控制
     * 修复点：
     * currentTime >= 30 后只触发一次，避免重复 pause/playNextVideo。
     */
    handlePlayerTimeUpdate() {
      const video = this.getCurrentPlayer();

      if (!video) return;
      if (this.playType !== "video") return;
      if (this.isChangingVideo) return;

      const currentTime = video.currentTime || 0;
      const playTimeLimit = this.baseData.play_time || 120;

      if (currentTime >= playTimeLimit) {
        this.isChangingVideo = true;

        try {
          video.pause();
        } catch (e) {}

        this.isPlaying = false;

        if (this.isContinuous) {
          setTimeout(() => {
            this.playNextVideo();
          }, 150);
        } else {
          setTimeout(() => {
            this.isChangingVideo = false;
          }, 300);

          if (!this.checkPlayLimit(true)) {
            // checkPlayLimit 内部处理提示
          } else {
            this.$toast("该视频已看完，请播放下个视频");
          }
        }
      }
    },

    checkPlayLimit(showPrompt = true) {
      let allowedCount = parseInt(this.baseData.times || 0);

      if (allowedCount <0) {
        if (this.is_jump == 1) {
          this.goHome();
        }

        if (showPrompt) {
          this.$toast("今日免费已看完，请分享获取更多次数");
          this.showShareModal = true;
        }

        return false;
      }
      
      // 每次播放有效视频时扣减一次次数
      //this.baseData.times = allowedCount - 1;
      return true;
    },

    playLiveStream() {
      if (this.baseData.live && this.baseData.live.url) {
        this.playType = "live";
        this.currentVideoUrl = this.baseData.live.url;
        this.currentVideoId = null;
        this.isChangingVideo = false;
        this.startPlayForce();
        this.$toast("已切换到直播源");
        this.showShareModal = false;zhi
      } else {
        this.$toast("当前没有直播流可播放");
        this.showShareModal = false;
      }
    },

    playVodStream() {
      this.playType = "video";

      if (this.baseData.video && this.baseData.video.url) {
        this.currentVideoUrl = this.baseData.video.url;
        this.isChangingVideo = false;
        
        // 切换到视频板块时不自动播放，只初始化播放器状态，也不要显示播放器容器
        this.showPlayer = false; // 改为 false，彻底隐藏 video，露出底层容器背景
        this.isPlaying = false;
        this.isVideoReady = false;
        
        this.stopAllPlayers();
        
        this.$nextTick(() => {
          // 不再调用 initNativeVideo，xgplayer 实例会自动处理
        });

        this.$toast("已切换到点播视频");
      } else {
        this.playNextVideo();
      }
    },

    playNextVideo() {
      if (this.isChangingVideo && this.isAutoPlaying) {
        return;
      }

      // 切换下一个视频前，先暂停当前正在播放的视频
      const video = this.getCurrentPlayer();
      if (video && !video.paused) {
        video.pause();
      }

      // 检查后端返回的剩余次数
      if (this.baseData.times !== undefined && this.baseData.times <= 0) {
        this.showShareModal = true;
        this.$toast("免费观看次数已用完，请先分享!");
        return;
      }

      this.isChangingVideo = true;

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true
      });

      getVideo()
        .then(res => {
          this.$toast.clear();

          if (res) {
            const temp = JSON.parse(this.$decryptData(res));
            
            if (temp.code === 0) {
              this.isChangingVideo = false;
              this.$toast(temp.msg || temp[0] || "获取视频失败");
              if (temp[0] === '免费观看次数已用完,请先分享!' || temp.msg === '免费观看次数已用完,请先分享!') {
                 this.showShareModal = true;
              }
              return;
            }

            if (temp.video && temp.video.url) {
              this.playType = "video";
              this.currentVideoUrl = temp.video.url;
              this.baseData.video = temp.video;
              this.currentVideoId = null;
              this.baseData.times=temp.times;
              this.isChangingVideo = false;
              this.startPlayForce();
            } else {
              this.isChangingVideo = false;
              this.$toast("未获取到视频");
               this.showShareModal = true;
            }
          } else {
            this.isChangingVideo = false;
            this.$toast("未获取到视频");
            this.showShareModal = true;
          }
        })
        .catch(err => {
          this.isChangingVideo = false;
          this.$toast.clear();
          this.$toast("获取视频失败");
        });
    },

    playNextLive() {
      if (this.isChangingVideo && this.isAutoPlaying) {
        return;
      }

      const video = this.getCurrentPlayer();
      if (video && !video.paused) {
        video.pause();
      }

      this.isChangingVideo = true;

      this.$toast.loading({
        message: "加载直播中...",
        forbidClick: true
      });

      getLiveVideo()
        .then(res => {
          this.$toast.clear();

          if (res) {
            const temp = JSON.parse(this.$decryptData(res));
            
            if (temp.code === 0) {
              this.isChangingVideo = false;
              this.$toast(temp.msg || temp[0] || "获取直播失败");
              return;
            }

            if (temp.live && temp.live.url) {
              this.playType = "live";
              this.currentVideoUrl = temp.live.url;
              this.baseData.live = temp.live;
              this.currentVideoId = null;
              this.isChangingVideo = false;
              this.startPlayForce();
            } else {
              this.isChangingVideo = false;
              this.$toast("未获取到直播");
            }
          } else {
            this.isChangingVideo = false;
            this.$toast("未获取到直播");
          }
        })
        .catch(err => {
          this.isChangingVideo = false;
          this.$toast.clear();
          this.$toast("获取直播失败");
        });
    },

    toggleContinuous() {
      this.isContinuous = !this.isContinuous;
      this.$toast(this.isContinuous ? "已开启连续播放" : "已关闭连续播放");
    },

    handleVideoEnded() {
      if (this.isContinuous && this.playType === "video") {
        this.playNextVideo();
      } else {
        this.isPlaying = false;
      }
    },

    goHome() {
      this.destroyPlayer(true);
      this.showPlayer = false;
      this.$router.push("/");
    },

    goPay() {
      this.$router.push("/pay");
    },

    handleGoShare() {
      if (this.shareUrl) {
        this.handelClickCopy('高清视频请复制到浏览器永久打开:'+this.shareUrl);
        const params = {
          ...this.$route.query,
          ldk: this.params.ldk,
          uid: this.params.uid
        };
        liveShareLogApi(params).then(() => {
          this.showShareModal = false;
        }).catch(err => {
          // 忽略异常
        });
      } else {
        this.$toast("获取分享链接失败");
      }
    },

    handleShareDone() {
      this.$toast.loading({
        message: "正在刷新状态...",
        forbidClick: true
      });

      const query = this.$route.query;

      initData(query)
        .then(res => {
          this.$toast.clear();
        
          if (res) {
            const temp = JSON.parse(this.$decryptData(res));
            
            this.baseData.times = temp.times;
            this.baseData.jump_url = temp.jump_url;

            if (this.baseData.times > 0) {
              this.$toast("刷新成功，您已获得新的观看次数！");
              this.showShareModal = false;
            } else {
             
               if(temp.free_video_num>=10){
                this.$toast("今日免费观看次数已用完，请明天继续观看！");
                this.showShareModal = false;
               }else if(temp.times<=0 && temp.free_video_num<10){
                this.$toast("暂未检测到有效分享，请确保好友已打开链接。");
                this.showShareModal = false;
               }else{
                this.showShareModal = false;
               }
            }
          }else{
             this.showShareModal = false;
          }
        })
        .catch(() => {
          this.$toast.clear();
        });
    },

    showPayModal() {
      let vid =
        this.playType === "live"
          ? this.baseData.live
            ? this.baseData.live.id
            : 0
          : this.baseData.video
          ? this.baseData.video.id
          : 0;

      let datas = {
        ldk: this.params.ldk,
        uid: this.params.uid,
        vid: vid
      };

      let localPayBtnList = window.localStorage.getItem("localPayBtnList");

      if (localPayBtnList && localPayBtnList !== "undefined" && localPayBtnList !== null) {
        let temp = JSON.parse(this.$decryptData(localPayBtnList));
        this.payBtnList = temp;
        this.payBoxModal = true;
      } else {
        pvv6Api(datas).then(res => {
          let temp = JSON.parse(this.$decryptData(res));
          this.payBtnList = temp;
          this.payBoxModal = true;
          window.localStorage.setItem("localPayBtnList", res);
        });
      }
    },

    closeDig(action, done) {
      done();
    },

    closeDigNew() {
      this.payBoxModal = false;

      const video = this.getCurrentPlayer();

      if (video) {
        try {
          video.pause();
        } catch (e) {}
      }

      this.isPlaying = false;
      this.isAutoPlaying = false;
    },

    handelClickCopy(text) {
      this.$copyText(text)
        .then(() => {
          this.$toast("复制成功");
        })
        .catch(() => {
          this.$toast("复制失败");
        });
    },

    linkTo(item) {
      this.goodsInfo = item;
      this.payModal = true;
    },

    goPayOrder(pay_id) {
      let that = this;

      if (!that.goodsInfo) {
        that.$toast("请选择影视资源类型");
        return;
      }

      let ip = window.localStorage.getItem("IP");

      let vid =
        this.playType === "live"
          ? this.baseData.live
            ? this.baseData.live.id
            : 0
          : this.baseData.video
          ? this.baseData.video.id
          : 0;

      let data = {
        pay_id: pay_id,
        ip: ip,
        uid: that.params.uid,
        vid: vid,
        ldk: this.params.ldk,
        is_type: this.goodsInfo.is_type
      };

      pav7Api(data).then(res => {
        let temp = JSON.parse(that.$decryptData(res));

        if (temp.code == 1) {
          if (temp.data.payurl) {
            if (temp.data.is_iframe == 1) {
              this.$router.push({
                path: "/pay",
                query: {
                  payurl: temp.data.payurl
                }
              });
            } else {
              window.location.href = temp.data.payurl;
            }
          }
        } else {
          that.$toast.fail(temp.msg);
        }
      });
    }
  }
};
</script>

<style scoped>
.van-icon .van-icon-volume-o .van-notice-bar__left-icon {
  color: #fff !important;
}

.live-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: auto; /* 依赖 top/bottom 自动撑开，避免 100vh 带来的浏览器导航栏遮挡问题 */
  width: 100%;
  background-size: cover;
  background-position: center;
  overflow: hidden;
}

/* 视频层：点播视频层需要让底部的原生进度条可以点击，但视频本体允许交互 */
.video-layer {
   width:100%;
    position:relative;
    overflow:hidden;
     background-color: #000;
     height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

 .native-video {
   width:100%;
    height:220px !important;
   
}


/* .native-video video {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain !important;
}  */

/* 尽量隐藏 WebKit 原生控制栏 */
.no-controls::-webkit-media-controls {
  display: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
}

.no-controls::-webkit-media-controls-enclosure {
  display: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
}

.no-controls::-webkit-media-controls-panel {
  display: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
}

.no-controls::-webkit-media-controls-play-button {
  display: none !important;
}

.no-controls::-webkit-media-controls-start-playback-button {
  display: none !important;
  -webkit-appearance: none;
}

.no-controls::-webkit-media-controls-fullscreen-button {
  display: none !important;
}

.no-controls::-webkit-media-controls-timeline {
  display: none !important;
}

.no-controls::-webkit-media-controls-current-time-display {
  display: none !important;
}

.no-controls::-webkit-media-controls-time-remaining-display {
  display: none !important;
}

.no-controls::-webkit-media-controls-mute-button {
  display: none !important;
}

.no-controls::-webkit-media-controls-volume-slider {
  display: none !important;
}

/* 顶部公告栏必须在视频上方 */
.custom-notice {
  font-size: 14px;
  height: 40px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999 !important;
  pointer-events: none; /* 穿透 */
}

.custom-notice * {
  pointer-events: auto;
}

/* 底部操作栏（包含两行：导航行 + 控制行） */
.bottom-controls {
  position: absolute;
  bottom: 0px; /* 避开原生进度条和底部导航 */
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 200;
  pointer-events: none; /* 容器穿透 */
  padding-bottom: 20px;
}

/* 导航行（精选、精品、视频、直播） */
.category-row {
  display: flex;
  justify-content: space-around;
  width: 90%;
  margin-bottom: 15px; /* 与下方控制按钮保持间距 */
  background: rgba(0, 0, 0, 0.4);
  border-radius: 20px;
  padding: 10px 0;
  backdrop-filter: blur(5px);
  pointer-events: auto; /* 恢复点击 */
}

.category-btn-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  font-size: 12px;
}

.category-icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
  font-size: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  color: #fff !important;
}
.category-btn-item span {
  color: #fff !important;
}

.btn-yellow { background: linear-gradient(135deg, #f1c40f, #f39c12); }
.btn-orange { background: linear-gradient(135deg, #e67e22, #d35400); }
.btn-pink { background: linear-gradient(135deg, #ff7eb3, #ff758c); }
.btn-red { background: linear-gradient(135deg, #e74c3c, #c0392b); }

/* 原本的播放控制栏 */
.control-row {
  display: flex;
  gap: 10px;
  width: 100%;
  position: relative;
  z-index: 10000 !important;
}

.btn-item {
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-sizing: border-box;
  transition: opacity 0.2s;
  position: relative;
  z-index: 10000 !important;
  pointer-events: auto; /* 恢复按钮自身的点击响应 */
}

.btn-item:active {
  opacity: 0.8;
}

.btn-large {
  flex: 2;
  height: 60px;
  padding-left: 15px;
  justify-content: flex-start;
  gap: 15px;
}

.btn-small {
  flex: 1;
  height: 60px;
  gap: 4px;
}

.btn-gradient {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.1));
  border: 1px solid rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.btn-gradient .icon-wrap {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #ff4b2b, #ff416c);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  box-shadow: 0 2px 8px rgba(255, 65, 108, 0.4);
}

.btn-text-large {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 1px;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
}

.btn-white-trans {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.7));
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.icon-red {
  color: #ff416c;
  font-size: 22px;
}

.btn-text-red {
  color: #ff416c;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
}

.icon-pink {
  color: #e1306c;
  font-size: 22px;
}

.btn-text-pink {
  color: #e1306c;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
}

.btn-dark-trans {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.icon-white {
  color: #fff;
  font-size: 22px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.icon-yellow {
  color: #f1c40f;
  font-size: 22px;
}

.btn-text-stack {
  display: flex;
  flex-direction: column;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: 1px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.btn-yellow {
  background: linear-gradient(135deg, #f1c40f, #f39c12);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 15px rgba(243, 156, 18, 0.3);
}

.btn-orange {
  background: linear-gradient(135deg, #e67e22, #d35400);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 15px rgba(211, 84, 0, 0.3);
}

.btn-text-white {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.pay-code-section {
  text-align: center;
  margin: 5px auto;
  width: 90%;
}

.pay-code-tip {
  color: #f53036;
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 5px;
}

.pay-code-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #666;
  background: #fff;
  width: 100%;
}

.pay-code-text {
  flex: 1;
  padding: 6px 8px;
  font-size: 14px;
  color: #333;
}

.pay-code-copy {
  background: #4b4b52;
  color: #fff;
  padding: 8px 16px;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}

.pay-action-btns {
  display: flex;
  justify-content: space-between;
  width: 90%;
  margin: 5px auto 10px;
  gap: 10px;
}

.pay-action-btn {
  flex: 1;
  background: #4b4b52;
  color: #fff;
  text-align: center;
  padding: 8px 0;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

/* ================= 极客风分享弹窗 ================= */
::v-deep .cyber-share-dialog {
  background: rgba(20, 20, 30, 0.85) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 20px !important;
  color: #fff;
  width: 85%;
  max-width: 340px;
  z-index: 3001 !important;
}

.cyber-share-container {
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.cyber-share-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.cyber-share-header .header-icon {
  font-size: 24px;
  color: #ff416c;
}

.cyber-share-header .header-title {
  font-size: 18px;
  font-weight: bold;
  background: linear-gradient(135deg, #ff4b2b, #ff416c);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 1px;
}

.cyber-share-body {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.tips-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 15px;
  font-size: 14px;
  line-height: 1.6;
  color: #ddd;
  text-align: justify;
}

.tips-card .highlight {
  color: #ff416c;
  font-weight: bold;
}

.tips-card .num {
  font-size: 16px;
  margin: 0 2px;
}

.link-card {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 65, 108, 0.3);
  border-radius: 12px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.link-title {
  font-size: 14px;
  color: #ff4b2b;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: bold;
}

.link-content {
  font-size: 12px;
  color: #aaa;
  line-height: 1.5;
}

.link-url {
  margin-top: 6px;
  color: #fff;
  word-break: break-all;
  background: rgba(255, 255, 255, 0.08);
  padding: 8px 10px;
  border-radius: 6px;
  font-family: monospace;
}

.cyber-share-footer {
  display: flex;
  gap: 15px;
  margin-top: 5px;
}

.cyber-btn {
  flex: 1;
  height: 44px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;
}

.cyber-btn:active {
  transform: scale(0.95);
}

.cyber-btn-cancel {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.cyber-btn-confirm {
  background: linear-gradient(135deg, #ff4b2b, #ff416c);
  color: #fff;
  box-shadow: 0 4px 15px rgba(255, 65, 108, 0.4);
}

#live-player .xgplayer-controls {
    display:none!important;
}

#live-player .xgplayer-progress {
    display:none!important;
}

#live-player .xgplayer-play {
    display:none!important;
}




#live-player,
#live-player .xgplayer {
    width:100%;
    height:220px;
}
/* === 已移除之前的 right-controls 样式 === */
</style>

<style>
/* 提升 toast 的层级，确保在分享弹窗等高层级元素之上 */
.van-toast {
  z-index: 10000 !important;
}
</style>